module.exports = __webpack_public_path__ + "static/media/dark-submenu-pesquisa.d64e5c3b.svg";